import { Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { DirProposalType } from '@econtractor/types';
import EToolTip from 'components/others/EToolTip';

interface ProposalCardProps {
    proposal: DirProposalType;
    canEdit?: boolean;
    onEdit: (proposalId: number) => void;
    onDuplicate: (proposalId: number) => void;
    onDelete: (proposal: DirProposalType) => void;
}

const ProposalCard = ({ proposal, canEdit = false, onEdit, onDuplicate, onDelete }: ProposalCardProps) => {
    const { t } = useTranslation(['Proposal', 'common']);

    return (
        <Card className="h-100">
            <Card.Body>
                <h6
                    className="mb-2 cursor-pointer text-break"
                    onClick={() => onEdit(proposal.ID)}
                >
                    {proposal.proposalName || t('card.noName')}
                </h6>
                <div className="text-muted fs-12 mb-0">
                    {proposal.proposalComment || t('card.noComment')}
                </div>
            </Card.Body>
            {canEdit ? (
                <Card.Footer className="bg-transparent border-0 pt-0">
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <EToolTip title={t('card.duplicate')}>
                            <Button
                                size="sm"
                                variant="light"
                                className="px-2"
                                onClick={(e) => {
                                    e.currentTarget.blur();
                                    onDuplicate(proposal.ID);
                                }}
                                aria-label={t('card.duplicate')}
                            >
                                <i className="bi bi-copy"></i>
                            </Button>
                        </EToolTip>
                        <Button size="sm" variant="light" onClick={() => onEdit(proposal.ID)}>
                            {t('common:buttons.change')}
                        </Button>
                        <Button
                            size="sm"
                            variant="light-danger"
                            onClick={() => onDelete(proposal)}
                        >
                            {t('common:buttons.delete')}
                        </Button>
                    </div>
                </Card.Footer>
            ) : null}
        </Card>
    );
};

export default ProposalCard;
